// extracted by mini-css-extract-plugin
module.exports = {"container":"Main__container__3Ss_E","titleBar":"Main__titleBar__ROtlN","content":"Main__content__2Zgbj"};